import { render } from "./foot.vue?vue&type=template&id=bbf4f292&scoped=true"
import script from "./foot.vue?vue&type=script&lang=js"
export * from "./foot.vue?vue&type=script&lang=js"

import "./foot.vue?vue&type=style&index=0&id=bbf4f292&lang=scss&scoped=true"

import exportComponent from "/data/heYou-h5/panther-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf4f292"]])

export default __exports__